module.exports = __webpack_public_path__ + "static/media/livestream-dark.25a67fff.svg";